/**
 * Designed by OnHOW YouTube Channel - Anas El Medlaoui
 * UI Enhanced version - Compatible with Dawn, Horizon & Dlsmart
 */

const onhowStyles = `
  .onhow-accordion {
    width: 100% !important;
    max-width: 100% !important;
    max-inline-size: 100% !important;
    box-sizing: border-box;
  }

  .onhow-accordion details:first-of-type {
    border-top: 1px solid rgba(128, 128, 128, 0.2);
  }

  .onhow-accordion details {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(128, 128, 128, 0.2);
  }
  
  .onhow-accordion summary {
    width: 100% !important;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    padding: 1.2rem 0;
    list-style: none; /* Hide default triangle */
    outline: none;
    transition: opacity 0.2s ease;
  }
  
  /* Hide default details marker for WebKit browsers */
  .onhow-accordion summary::-webkit-details-marker {
    display: none; 
  }
  
  .onhow-accordion summary:hover {
    opacity: 0.7;
  }
  
  .onhow-accordion .summary__title {
    flex-grow: 1;
    padding-right: 1rem;
  }

  .onhow-accordion .accordion__title {
    margin: 0;
    font-size: calc(var(--font-heading-scale, 1) * 1.13em); 
    font-weight: 600;
    line-height: 1.4;
  }
  
  .onhow-accordion .icon-caret {
    width: 1.2rem;
    height: 1.2rem;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1); /* Smooth rotation */
  }
  
  /* Rotate arrow 180 degrees when details tag is open */
  .onhow-accordion details[open] .icon-caret {
    transform: rotate(180deg); 
  }
  
  .onhow-accordion .accordion__content {
    padding-bottom: 1.5rem;
    color: inherit;
    line-height: 1.6;
    width: 100% !important;
    box-sizing: border-box;
  }
  
  .onhow-accordion details[open] .accordion__content {
    animation: slowReveal 400ms ease-in-out; 
  }
  
  @keyframes slowReveal {
    0% { opacity: 0; transform: translateY(-5px); }
    100% { opacity: 1; transform: translateY(0); }
  }

  /* Full width overrides for Dlsmart / Horizon text blocks */
  .has-onhow-accordion,
  .product-details rte-formatter,
  .product-details .text-block,
  .text-block:has(.onhow-accordion),
  rte-formatter:has(.onhow-accordion) {
    width: 100% !important;
    max-width: 100% !important;
    max-inline-size: 100% !important;
    --max-width: 100% !important;
    --width: 100% !important;
    align-items: stretch !important;
  }

  .has-onhow-accordion > *,
  .product-details .text-block > .onhow-accordion,
  .product-details rte-formatter > .onhow-accordion {
    width: 100% !important;
    max-width: 100% !important;
    max-inline-size: 100% !important;
  }
`;

function addStyles(stylesText) {
  if (document.getElementById('onhow-accordion-styles')) return;
  const styleElement = document.createElement('style');
  styleElement.id = 'onhow-accordion-styles';
  styleElement.textContent = stylesText;
  document.head.appendChild(styleElement);
}

class OnhowDescriptionAccordion {
  constructor(container) {
    this.descriptionContainer = container;
    if (!this.descriptionContainer || this.descriptionContainer.dataset.accordionInitialized === 'true') return;
    
    addStyles(onhowStyles);
    this.init();
  }

  init() {
    this.originalContent = this.descriptionContainer.innerHTML;
    
    const h3Elements = this.descriptionContainer.querySelectorAll('h3');
    if (h3Elements.length > 0) {
      this.createAccordion(h3Elements);
    }
  }

  createAccordion(h3Elements) {
    this.descriptionContainer.dataset.accordionInitialized = 'true';
    this.descriptionContainer.classList.add('has-onhow-accordion');
    this.descriptionContainer.style.setProperty('width', '100%', 'important');
    this.descriptionContainer.style.setProperty('max-width', '100%', 'important');
    this.descriptionContainer.style.setProperty('max-inline-size', '100%', 'important');
    this.descriptionContainer.style.setProperty('--max-width', '100%', 'important');
    this.descriptionContainer.style.setProperty('align-items', 'stretch', 'important');

    const parentBlock = this.descriptionContainer.closest('.text-block');
    if (parentBlock) {
      parentBlock.classList.add('has-onhow-accordion');
      parentBlock.style.setProperty('width', '100%', 'important');
      parentBlock.style.setProperty('max-width', '100%', 'important');
      parentBlock.style.setProperty('max-inline-size', '100%', 'important');
      parentBlock.style.setProperty('--max-width', '100%', 'important');
      parentBlock.style.setProperty('align-items', 'stretch', 'important');
    }

    const accordionContainer = document.createElement('div');
    accordionContainer.className = 'onhow-accordion product__accordion accordion quick-add-hidden';
    accordionContainer.style.width = '100%';

    // Check if there is any content before the first h3 (intro paragraph, badges, etc.)
    const firstH3 = h3Elements[0];
    let introElements = [];
    let prev = firstH3.previousElementSibling;
    while (prev) {
      introElements.unshift(prev.cloneNode(true));
      prev = prev.previousElementSibling;
    }
    if (introElements.length > 0) {
      const introDiv = document.createElement('div');
      introDiv.className = 'onhow-intro rte';
      introDiv.style.marginBottom = '1rem';
      introElements.forEach(element => {
        introDiv.appendChild(element);
      });
      accordionContainer.appendChild(introDiv);
    }

    const shouldOpenFirst = window.accordionConfig ? window.accordionConfig.openFirst !== false : true;

    h3Elements.forEach((h3Element, index) => {
      let contentElements = [];
      let currentElement = h3Element.nextElementSibling;
      
      while (currentElement && currentElement.tagName !== 'H3') {
        contentElements.push(currentElement.cloneNode(true));
        currentElement = currentElement.nextElementSibling;
      }
      
      const details = document.createElement('details');
      details.id = `Details-onhow-${index}`;
      const isOpen = index === 0 && shouldOpenFirst;
      if (isOpen) details.setAttribute('open', '');
      
      const summary = document.createElement('summary');
      summary.setAttribute('role', 'button');
      summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      summary.setAttribute('aria-controls', `ProductAccordion-onhow-${index}`);
      
      const summaryTitle = document.createElement('div');
      summaryTitle.className = 'summary__title';
      
      const heading = document.createElement('h2');
      heading.className = 'h4 accordion__title';
      heading.textContent = h3Element.textContent;
      
      const iconContainer = document.createElement('span');
      // Sleek dropdown chevron
      iconContainer.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-caret" aria-hidden="true" focusable="false">
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>`;
      
      const content = document.createElement('div');
      content.className = 'accordion__content rte';
      content.id = `ProductAccordion-onhow-${index}`;
      
      contentElements.forEach(element => {
        content.appendChild(element);
      });
      
      summaryTitle.appendChild(heading);
      summary.appendChild(summaryTitle);
      summary.appendChild(iconContainer);
      details.appendChild(summary);
      details.appendChild(content);
      accordionContainer.appendChild(details);
    });
    
    this.descriptionContainer.innerHTML = '';
    this.descriptionContainer.appendChild(accordionContainer);
    
    this.initializeAccordion();
  }

  initializeAccordion() {
    const detailsElements = this.descriptionContainer.querySelectorAll('details');
    
    detailsElements.forEach(details => {
      const summary = details.querySelector('summary');
      summary.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !details.hasAttribute('open'));
      });
      
      details.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;
        
        const summaryElement = openDetailsElement.querySelector('summary');
        openDetailsElement.removeAttribute('open');
        summaryElement.setAttribute('aria-expanded', 'false');
        summaryElement.focus();
      });
    });
  }
  
  restoreOriginalDescription() {
    if (this.originalContent) {
      this.descriptionContainer.innerHTML = this.originalContent;
      delete this.descriptionContainer.dataset.accordionInitialized;
    }
  }
}

(function() {
  function getContainer() {
    const selectors = [
      '.product__description.rte',
      '.product__description',
      '.product-details rte-formatter',
      '.product-details .rte',
      '[data-testid="product-information-details"] rte-formatter',
      '[data-testid="product-information-details"] .rte',
      'rte-formatter'
    ];
    const candidates = document.querySelectorAll(selectors.join(', '));
    for (const el of candidates) {
      if (el.querySelectorAll('h3').length > 0) {
        return el;
      }
    }
    return candidates[0] || null;
  }

  function initAccordion() {
    const container = getContainer();
    if (container) {
      new OnhowDescriptionAccordion(container);
    } else if (document.readyState !== 'complete') {
      setTimeout(initAccordion, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordion);
  } else {
    initAccordion();
  }

  document.addEventListener('shopify:section:load', () => {
    setTimeout(initAccordion, 50);
  });
})();
